import { render } from "./BokFailure.vue?vue&type=template&id=23c99f76"
import script from "./BokFailure.vue?vue&type=script&lang=js"
export * from "./BokFailure.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__